import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Field, Form, TextArea } from '@/components';
import { nullableStringSetter } from '@/helpers';

import { CompanySchema } from '../../types';

export type AboutFormFields = {
  description: string | null;
};

export type AboutFormProps = {
  readonly id: string;
  readonly company: CompanySchema;
  readonly onSubmit: (data: AboutFormFields) => void;
};

export function AboutForm({ id, company, onSubmit }: AboutFormProps) {
  const { t } = useTranslation(['settings']);

  const options = useMemo(
    () => ({ defaultValues: { description: company.description ?? null } }),
    [company]
  );

  return (
    <Form<AboutFormFields> id={id} onSubmit={onSubmit} options={options}>
      {({ register }) => (
        <Field id="description" label={t('About')} classes={{ field: 'space-y-1' }}>
          <TextArea
            id="description"
            className="min-h-35"
            placeholder={t('Describe your company: who you are and what you look for.')}
            registration={register('description', { setValueAs: nullableStringSetter })}
          />
        </Field>
      )}
    </Form>
  );
}
